import styled from '@emotion/styled'
import { ListItemIcon, ListItemText, MenuItem as MuiMenuItem } from '@mui/material'
import { memo } from 'react'

import { Text } from '../../foundations/index.ts'
import { Dialog } from '../../patterns/dialog/dialog.tsx'
import { Avatar } from '../avatar/index.ts'

import type { MenuItem } from './menu.tsx'

type DialogMenuListProps = {
  menuItems: MenuItem[]
  handleClose: () => void
  open: boolean
  onChange: (value: string) => void
  anchorElement: HTMLElement | null
}

export const DialogMenuList = memo<DialogMenuListProps>(function MenuList(props) {
  const { menuItems, open, handleClose, onChange } = props

  if (!open) return

  return (
    <Dialog onClose={handleClose} size="large">
      <Container>
        {menuItems.map((item) => {
          if ('divider' in item) {
            return null
          }

          return (
            <MuiMenuItem key={item.value}>
              {item.icon ? (
                <ListItemIcon>
                  <Avatar icon={item.icon} size="30" />
                </ListItemIcon>
              ) : null}
              <ListItemText onClick={() => onChange(item.value)}>
                <Text>{item.label}</Text>
              </ListItemText>
            </MuiMenuItem>
          )
        })}
      </Container>
    </Dialog>
  )
})

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`
